import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'error-messages:api-call-rate-limited': {
    id: 'error-messages:api-call-rate-limited',
    defaultMessage: "You've recently made too many attempts to make a change. Please try again later.",
    description: 'Rate limiting error message',
  },
  'error-messages:operation-not-permitted-for-csr': {
    id: 'error-messages:operation-not-permitted-for-csr',
    defaultMessage: 'This action is not allowed as a CSR.',
    description: "Error message for a non permitted operation during member's session impersonated by a CSR",
  },
});
